import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Button } from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";

import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import DefaultFooter from "../../components/Footers/DefaultFooter";
import KodeEtikPageHeader from "components/Headers/KodeEtikPageHeader";

const KodeEtikPage = () => {
    const [data, setData] = useState({
        deskripsi: "",
        foto: "",
        dokumen: "",
    });

    useEffect(() => {
        AOS.init();
        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/etik/readKodeEtik`
                );
                console.log(response.data);

                if (response.data.length > 0) {
                    setData(response.data[0]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        return () => {
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <KodeEtikPageHeader />

            <div className="wrapper">
                <section className="sec__one governance wbs-section">
                    <Container>
                        {/* ===== COVER IMAGE ===== */}
                        {data.foto && (
                            <Row className="justify-content-center mt-5">
                                <Col lg="10" data-aos="fade-up">
                                    <img
                                        src={data.foto}
                                        alt="Cover"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                            </Row>
                        )}

                        {/* ===== CONTENT CARD ===== */}
                        <Row className="justify-content-center mt-5 mb-5">
                            <Col lg="10" md="11">
                                <div
                                    className="p-5"
                                    style={{
                                        maxWidth: "900px",
                                        margin: "0 auto",
                                        lineHeight: "1.8",
                                        fontSize: "18px",
                                    }}
                                    data-aos="fade-up"
                                >
                                    <h2 className="text-center mb-4">Kode Etik YKBUT</h2>

                                    {/* DESKRIPSI WITH RESPONSIVE TEXT WRAPPING */}
                                    <div
                                        style={{
                                            whiteSpace: "pre-line",
                                            textAlign: "justify",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {data.deskripsi}
                                    </div>

                                    {/* BUTTON */}
                                    <div className="text-center mt-4">
                                        {data.dokumen && (
                                            <a
                                                href={data.dokumen}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Button
                                                    color="primary"
                                                    style={{
                                                        padding: "12px 28px",
                                                        fontSize: "16px",
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    Read More
                                                </Button>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <DefaultFooter />
            </div>
        </>
    );
};

export default KodeEtikPage;
